// src/v3/ui/locales/en.ts

export const en = {
  "dataPage.empty": "No data found.",
  "aiAgent.recentAnalyses": "Recent Analyses",
  "aiAgent.refresh": "Refresh",
  "aiAgent.empty": "No analyses found. Click Refresh to load.",
  "aiAgent.column.agent": "Agent",
  "aiAgent.column.target": "Target",
  "aiAgent.column.date": "Date",
  "aiAgent.column.verdict": "Verdict",
  "aiAgent.column.confidence": "Confidence",
  "aiAgent.detail.verdict": "Verdict",
  "aiAgent.detail.confidence": "Confidence",
  "aiAgent.detail.date": "Date",
  "aiAgent.detail.edit": "Edit",
  "aiAgent.detail.editAria": "Edit analysis text",
  "aiAgent.detail.cancel": "Cancel",
  "aiAgent.detail.save": "Save",
  "aiAgent.detail.regenerate": "Regenerate",
  "aiAgent.runAnalysis": "Run Analysis",
  "aiAgent.runAnalysis.title": "Run AI Analysis",
  "aiAgent.runAnalysis.success": "Analysis completed for {target}",
  "aiAgent.runAnalysis.error": "Failed to run analysis: {message}",
  "aiAgent.runAnalysis.unsupportedAgent": "Unsupported agent: {agent}",
  "pinbar.identify": "Identify",
  "pinbar.identify.title": "Identify Pinbars",
  "pinbar.identify.success": "Identified {count} pinbar(s) for {date}",
  "pinbar.identify.noPinbars": "No pinbars found for {date}",
  "pinbar.identify.error": "Failed to identify pinbars: {message}",
  "pinbar.identify.aiVerify": "AI Verify",
  "pinbar.identify.aiVerifySuccess": "AI verified {count} pinbar(s)",
  "pinbar.identify.aiVerifyError": "AI verify failed: {message}",
  "pinbar.identify.approveSuccess": "Pinbar approved",
  "pinbar.identify.rejectSuccess": "Pinbar rejected",
  "scheduler.cronJobs": "Cron Jobs",
  "scheduler.refresh": "Refresh",
  "scheduler.run": "Run",
  "scheduler.noJobs": "No jobs configured.",
  "scheduler.dependsOn": "Depends on",
  "scheduler.executionHistory": "Execution History",
  "scheduler.noHistory": "No execution history yet. Run a job to see logs.",
  "scheduler.column.job": "Job",
  "scheduler.column.started": "Started",
  "scheduler.column.finished": "Finished",
  "scheduler.column.status": "Status",
  "scheduler.column.result": "Result",
  "scheduler.params.required": "This field is required",
  "scheduler.params.invalidDate": "Date must be in YYYY-MM-DD format",
  "scheduler.params.invalidNumber": "Must be a valid number",
  "scheduler.params.selectPlaceholder": "Select...",
  "scheduler.runWithParams": "Run with params",
  "scheduler.cronExpression": "Cron Expression",
  "scheduler.saveCron": "Save",
  "scheduler.save": "Save",
  "scheduler.cronHint":
    "5-6 fields: minute hour day-of-month month day-of-week [year]. Example: '0 5 * * *' = daily at 05:00 UTC.",
  "scheduler.symbolsCronExpression": "Symbols Refresh Cron",
  "scheduler.symbolsCronHint":
    "Schedule for periodic symbol universe refresh (syncSymbols). Example: '0 0 * * 1' = weekly on Monday at 00:00 UTC.",
  "scheduler.edit": "Edit",
  "scheduler.cancel": "Cancel",
  "scheduler.frequency": "Frequency",
  "scheduler.frequencyDaily": "Daily",
  "scheduler.frequencyWeekly": "Weekly",
  "scheduler.frequencyCustom": "Custom cron",
  "scheduler.hour": "Hour (UTC)",
  "scheduler.minute": "Minute",
  "scheduler.dayOfWeek": "Day of week",
  "scheduler.preview": "Preview",
  "scheduler.nextRun": "Next run",
  "scheduler.lastRun": "Last run",
  "scheduler.progressCanClose":
    "You can close this page — progress is saved and you'll see the result when you return.",
  "scheduler.allJobs": "All jobs",
  "scheduler.schedule.daily": "Daily Pipeline",
  "scheduler.schedule.symbols-refresh": "Symbols Refresh",
  "scheduler.job.description.importCandles":
    "Imports candle data for a specific date from FMP",
  "scheduler.job.description.identifyPinbars":
    "Detects pinbar patterns in candle data",
  "scheduler.job.description.processSymbols":
    "Processes stale symbols (fetch external data, update aggregates)",
  "scheduler.job.description.syncSymbols":
    "Refreshes the symbol universe (new IPOs, delistings, marketCap updates)",
  "scheduler.day.sunday": "Sunday",
  "scheduler.day.monday": "Monday",
  "scheduler.day.tuesday": "Tuesday",
  "scheduler.day.wednesday": "Wednesday",
  "scheduler.day.thursday": "Thursday",
  "scheduler.day.friday": "Friday",
  "scheduler.day.saturday": "Saturday",
  "scheduler.notifications.title": "Failure Notifications",
  "scheduler.notifications.hint":
    "Get notified when a scheduled job fails. Secrets are stored on the server and shown masked.",
  "scheduler.notifications.channel": "Channel",
  "scheduler.notifications.channelNone": "Disabled",
  "scheduler.notifications.channelWebhook": "Webhook",
  "scheduler.notifications.channelTelegram": "Telegram",
  "scheduler.notifications.channelEmail": "Email",
  "scheduler.notifications.webhookUrl": "Webhook URL",
  "scheduler.notifications.botToken": "Bot Token",
  "scheduler.notifications.chatId": "Chat ID",
  "scheduler.notifications.smtpHost": "SMTP Host",
  "scheduler.notifications.smtpPort": "SMTP Port",
  "scheduler.notifications.smtpUser": "SMTP User",
  "scheduler.notifications.smtpPassword": "SMTP Password",
  "scheduler.notifications.emailFrom": "From",
  "scheduler.notifications.emailTo": "To",
  "scheduler.notifications.smtpSecure": "Use TLS/SSL (port 465)",
  "scheduler.notifications.save": "Save",
  "scheduler.notifications.test": "Send test",
  "scheduler.notifications.maskedHint":
    "Leave a masked field as-is (****) or empty to keep the stored value.",
  "backtester.title": "Backtester",
  "backtester.strategy": "Strategy",
  "backtester.version": "Version",
  "backtester.addStrategyHint":
    "Strategies are defined in code. To add a new strategy, create a file in src/v3/backtester/strategies/ and register it in STRATEGY_REGISTRY (src/v3/backtester/domain/strategy-registry.ts).",
  "backtester.optimizationParams": "Optimization Parameters",
  "backtester.params.name": "Param name",
  "backtester.params.min": "Min",
  "backtester.params.max": "Max",
  "backtester.params.step": "Step",
  "backtester.params.remove": "Remove parameter row",
  "backtester.params.addRow": "Add parameter",
  "backtester.params.invalidNumbers": "Invalid numbers for parameter {name}",
  "backtester.params.invalidStep": "Step must be positive for parameter {name}",
  "backtester.params.empty": "Add at least one parameter with valid values",
  "datasource.title": "Data Sources",
  "datasource.description":
    "Manually trigger data imports from external sources (FMP).",
  "datasource.importSymbols": "Import Symbols",
  "datasource.importSymbolsDesc":
    "Fetch and upsert symbols from FMP by exchange.",
  "datasource.importCandles": "Import Candles",
  "datasource.importCandlesDesc":
    "Fetch and upsert candles for a specific date.",
  "datasource.importPriceHistory": "Import Price History",
  "datasource.importPriceHistoryDesc":
    "Fetch full price history for given symbols.",
  "datasource.processAll": "Process All Symbols",
  "datasource.processAllDesc":
    "Run processing (enrich, relations, aggregates) for all symbols in DB. Uses cached FMP data when fresh.",
  "datasource.processAllRunning": "Processing...",
  "datasource.runImport": "Run Import",
  "datasource.importing": "Importing...",
  "datasource.importFailed": "Import failed",
  "datasource.importedSymbols": "Imported {count} symbols",
  "datasource.processedSymbols": "Processed {count} symbols",
  "datasource.enrichmentFailures": "{count} symbols without enrichment data",
  "datasource.candlesUpserted": "Upserted {count} candles",
  "datasource.candlesSaved": "Saved {count} candles",
  "datasource.candlesFiltered":
    "{count} candles filtered out (symbol not in allowed list)",
  "datasource.failedSymbols": "{count} symbols failed",
  "datasource.retryFailed": "Retry failed",
  "datasource.filteredOut": "{count} symbols filtered out",
  "datasource.symbolFilters": "Symbol Filters",
  "datasource.symbolFiltersDesc":
    "Criteria for filtering symbols during import. Toggle to enable/disable, edit thresholds to adjust.",
  "datasource.loading": "Loading...",
  "datasource.filterLabel": "Filter label",
  "datasource.filterProperty": "Property",
  "datasource.filterThreshold": "Threshold value",
  "datasource.dataFreshness": "Data Freshness",
  "datasource.never": "Never",
  "datasource.today": "Today",
  "datasource.yesterday": "Yesterday",
  "datasource.daysAgo": "{count} days ago",
  "datasource.stale": "Stale",
  "datasource.strategyVersion": "Strategy version: {version}",
  "datasource.strategyUpdated": "Strategy updated",
  "datasource.strategyUnchanged": "Strategy content unchanged",
  "datasource.date": "Date",
  "datasource.page": "Page",
  "datasource.successes": "Successes",
  "datasource.failures": "Failures",
  "datasource.dateLabel": "Date for candle import",
  "datasource.symbolsLabel": "Comma-separated symbols",
  "datasource.exchangesLabel": "Exchanges to import",
  "datasource.exchangeNASDAQ": "NASDAQ",
  "datasource.exchangeNYSE": "NYSE",
  "datasource.exchangeAMEX": "AMEX",
  "datasource.auditSymbols": "Audit existing symbols",
  "datasource.auditLoading": "Auditing...",
  "datasource.auditResult": "Out of {total} symbols, {count} do not match filters",
  "datasource.auditNoFilteredOut": "All {total} symbols match current filters",
  "datasource.auditError": "Audit failed",
  "datasource.deleteAll": "Delete all ({count})",
  "datasource.deleteSelected": "Delete selected ({count})",
  "datasource.auditConfirmTitle": "Confirm deletion",
  "datasource.auditConfirmBody":
    "This will delete {count} symbols with all related data: pinbars, candles, AI analyses, histories. This action is irreversible.",
  "datasource.auditConfirmCancel": "Cancel",
  "datasource.auditConfirmDelete": "Delete",
  "datasource.auditDeleting": "Deleting...",
  "datasource.auditDeleted":
    "Deleted {deleted} symbols, {pinbars} pinbars, {analyses} analyses, {candles} candles, {histories} histories, {historyEntries} history entries",
  "datasource.auditDeletedShort": "Deleted {deleted} symbols",
  "datasource.auditNothingToDelete": "Nothing to delete",
  "datasource.auditStale": "Filters changed — run audit again",
  "datasource.auditColTicker": "Ticker",
  "datasource.auditColName": "Name",
  "datasource.auditColReasons": "Reasons",
  "datasource.auditColActions": "Actions",
  "datasource.auditPage": "Page {page} of {total}",
  "datasource.auditPrev": "Previous",
  "datasource.auditNext": "Next",
  "table.edit.saveSuccess": "Saved {field} for {symbol}",
  "table.edit.saveError": "Failed to save {field}: {message}",
  "table.edit.reverted": "Value reverted to original",
  "symbol.action.process": "Process",
  "symbol.action.recalculate": "Recalculate",
  "symbol.action.delete": "Delete",
  "symbol.action.aria.process": "Process {symbol}",
  "symbol.action.skipAi": "Skip AI",
  "symbol.action.aria.recalculate": "Recalculate {symbol}",
  "symbol.action.aria.delete": "Delete {symbol}",
  "symbol.bulkEdit.processSelected": "Process Selected",
  "symbol.bulkEdit.recalculateSelected": "Recalculate Selected",
  "symbol.bulkEdit.deleteSelected": "Delete Selected",
  "symbol.bulkEdit.aria.processSelected": "Process selected symbols",
  "symbol.bulkEdit.aria.recalculateSelected": "Recalculate selected symbols",
  "symbol.bulkEdit.aria.deleteSelected": "Delete selected symbols",
  "symbol.delete.confirmTitle": "Confirm Delete",
  "symbol.delete.confirmMessage":
    "Are you sure you want to delete {count} symbol(s)? This action is irreversible and will remove all related data.",
  "symbol.delete.confirmConfirm": "Delete",
  "symbol.delete.confirmLoading": "Deleting...",
  "symbol.delete.confirmCancel": "Cancel",
  "symbol.delete.aria.confirmDialog": "Delete confirmation dialog",
  "symbol.delete.aria.confirmButton": "Confirm delete",
  "symbol.delete.aria.cancelButton": "Cancel delete",
  "symbol.result.success": "Operation completed successfully",
  "symbol.result.error": "Operation failed: {message}",
  "symbol.result.deleteSuccess": "Deleted {count} symbol(s)",
  "symbol.column.dataReceived": "Data Received",
  "symbol.recalculateNoPrice": "No price — run Process first",
  "symbol.audit.processSuccess": "Processed — re-run audit to refresh",
  "symbol.audit.processError": "Process failed: {message}",
  "symbol.audit.openCardLoading": "Loading symbol...",
  "symbol.audit.openCardError": "Failed to load symbol",
  "portfolio.brokerSync.title": "Broker sync",
  "portfolio.brokerSync.description": "Automatic operation imports from linked broker accounts.",
  "portfolio.brokerSync.enabled": "Synchronization is enabled",
  "portfolio.brokerSync.disabled": "Synchronization is disabled",
  "portfolio.brokerSync.emptyAccounts": "No accounts with synchronization",
  "portfolio.brokerSync.managementIntro": "Enter the management code to change broker settings or check a connection. Account status and open issues remain available without the code.",
  "portfolio.brokerSync.managementCode": "Management code",
  "portfolio.brokerSync.unlock": "Unlock settings",
  "portfolio.brokerSync.lock": "Lock settings",
  "portfolio.brokerSync.unlockError": "The code was rejected or broker settings are unavailable.",
  "portfolio.brokerSync.settingsError": "Could not load broker settings.",
  "portfolio.brokerSync.save": "Save settings",
  "portfolio.brokerSync.saving": "Saving…",
  "portfolio.brokerSync.saved": "Broker settings saved.",
  "portfolio.brokerSync.overlapDays": "Recheck previous days on each run",
  "portfolio.brokerSync.deepWindowDays": "Weekly history recheck window (days)",
  "portfolio.brokerSync.invalidNumber": "Enter a whole number within the allowed range.",
  "portfolio.brokerSync.secretSaved": "Secret is set",
  "portfolio.brokerSync.secretMissing": "Secret is not set",
  "portfolio.brokerSync.secretInputHint": "Leave empty to keep the saved value. Saved secrets cannot be viewed.",
  "portfolio.brokerSync.replaceSecret": "Enter a new secret to replace it",
  "portfolio.brokerSync.queryId": "Activity Flex Query ID",
  "portfolio.brokerSync.ibkrToken": "Flex Web Service token",
  "portfolio.brokerSync.tbankToken": "Read-only token",
  "portfolio.brokerSync.finamSecret": "Finam Trade API secret",
  "portfolio.brokerSync.instructions": "Setup instructions",
  "portfolio.brokerSync.ibkrInstructions": "In Performance & Reports → Flex Queries, create an Activity Flex Query. Enable three sections: Trades, Cash Transactions, and Corporate Actions. Use the XML format. Level of Detail: Execution in Trades, Detail in Cash Transactions and Corporate Actions. The synchronization reads exactly these rows; aggregates (Order, Symbol Summary, Summary) are not needed and are skipped when the statement contains them. In every section select all fields (Select All); without them operations are not recognized, and the Level of Detail field is what tells detail rows from aggregates. The synchronization reads these fields (XML attribute names; each matches the same-named Flex Query field, for example Account ID is accountId). Trades: accountId, accountAlias, currency, assetCategory, assetClass, subCategory, symbol, description, listingExchange, exchange, securityId, securityIdType, isin, cusip, tradeId, tradeDate, tradeTime, dateTime, transactionType, quantity, tradePrice, price, ibCommission, ibCommissionCurrency, buySell, proceeds, tradeMoney, multiplier, levelOfDetail. Cash Transactions: accountId, accountAlias, currency, assetCategory, assetClass, subCategory, symbol, description, listingExchange, exchange, securityId, securityIdType, isin, cusip, dateTime, amount, type, tradeId, code, levelOfDetail. Corporate Actions: accountId, accountAlias, currency, assetCategory, assetClass, subCategory, symbol, description, listingExchange, securityId, securityIdType, isin, cusip, dateTime, reportDate, amount, proceeds, value, quantity, code, type, transactionId, actionId, actionDescription, ratio, splitRatio, levelOfDetail. Keep the Query ID. In Flex Web Service Configuration, enable the service and create a token with the longest available lifetime: the default is 6 hours, so renew it when needed.",
  "portfolio.brokerSync.tbankInstructions": "Create a read-only token in T-Invest. InvestKopilka, managed, and Smart accounts cannot issue a token for one specific account. The token remains valid for 3 months after its last use.",
  "portfolio.brokerSync.finamInstructions": "Create a secret in the Tokens section of the Finam Trade API portal.",
  "portfolio.brokerSync.accountIdHint": "After checking the connection, choose a broker account ID from the result and enter it when linking an app account.",
  "portfolio.brokerSync.checkConnection": "Check connection",
  "portfolio.brokerSync.checkingConnection": "Checking…",
  "portfolio.brokerSync.connectionFailed": "Connection check failed",
  "portfolio.brokerSync.connectionHttpError": "Connection check failed: {reason}",
  "portfolio.brokerSync.invalidManagementCode": "The management code was rejected. Re-enter it and try again.",
  "portfolio.brokerSync.managementUnavailable": "Broker connection settings are not configured on this server.",
  "portfolio.brokerSync.brokerAccounts": "Broker accounts",
  "portfolio.brokerSync.noBrokerAccounts": "The broker returned no accounts.",
  "portfolio.brokerSync.historyAvailable": "Operation history is available ({count} records checked).",
  "portfolio.brokerSync.historyUnavailable": "Operation history could not be checked: {reason}",
  "portfolio.brokerSync.connectionNeedsAccounts": "Accounts were read, but operation history could not be checked: {reason}",
  "portfolio.brokerSync.accountsChecked": "Accounts checked: {count}.",
  "portfolio.brokerSync.historyAccount": "History was checked for broker account {accountId}.",
  "portfolio.brokerSync.connectionPartial": "History check finished: {checked} accounts checked, {failed} failed, {count} records read.",
  "portfolio.brokerSync.setupInstructions": "Broker setup instructions",
  "portfolio.brokerSync.runResults": "Run results",
  "portfolio.brokerSync.counterImported": "Imported",
  "portfolio.brokerSync.counterCreated": "Created",
  "portfolio.brokerSync.counterUpdated": "Updated",
  "portfolio.brokerSync.counterAppliedSplits": "Splits applied",
  "portfolio.brokerSync.counterDisappeared": "Missing from latest response",
  "portfolio.brokerSync.counterPairedTransfer": "Transfers paired",
  "portfolio.brokerSync.counterDeferredTransfer": "Transfers waiting",
  "portfolio.brokerSync.counterStandaloneTransfer": "Standalone transfers",
  "portfolio.brokerSync.counterOutOfScope": "Out of scope",
  "portfolio.brokerSync.counterUnsupported": "Unsupported operations",
  "portfolio.brokerSync.counterInvalidPayload": "Invalid records",
  "portfolio.brokerSync.counterUnmatchedInstrument": "Unmatched instruments",
  "portfolio.brokerSync.counterInstrumentCandidate": "Instrument review needed",
  "portfolio.brokerSync.counterCurrencyUnresolved": "Unresolved currencies",
  "portfolio.brokerSync.counterCorporateAction": "Corporate actions to review",
  "portfolio.brokerSync.counterSuppressedCommission": "Duplicate commissions suppressed",
  "portfolio.brokerSync.counterBeforeCutoff": "Before account start date",
  "portfolio.brokerSync.counterHelpTitle": "What do these results mean?",
  "portfolio.brokerSync.counterHelp": "Imported is the number of portfolio rows created or reconciled. Transfers paired were matched between linked accounts; transfers waiting still need their other leg. Out-of-scope records were deliberately skipped. Open issues need review before they can be imported.",
  "portfolio.brokerSync.noRunCounters": "No nonzero counters were reported for this run.",
  "portfolio.brokerSync.accountStatus": "Linked accounts",
  "portfolio.brokerSync.accountName": "App account",
  "portfolio.brokerSync.brokerAccountId": "Broker account ID",
  "portfolio.brokerSync.fromDate": "Import from",
  "portfolio.brokerSync.lastRun": "Last run",
  "portfolio.brokerSync.neverRun": "Not run yet",
  "portfolio.brokerSync.openIssues": "Open issues",
  "portfolio.brokerSync.intentionallySkipped": "Intentionally skipped",
  "portfolio.brokerSync.pendingTransfers": "Transfers waiting for a matching leg",
  "portfolio.brokerSync.runError": "Run error",
  "portfolio.brokerSync.issueList": "Open synchronization issues",
  "portfolio.brokerSync.noIssues": "No open issues.",
  "portfolio.brokerSync.issuesLoading": "Loading issues…",
  "portfolio.brokerSync.issuesError": "Could not load issues.",
  "portfolio.brokerSync.issuesTruncated": "Showing the newest {shown} of {total} issues.",
  "portfolio.brokerSync.issueDetails": "Operation data",
  "portfolio.brokerSync.operationKey": "Operation key",
  "portfolio.brokerSync.issueDetected": "Last seen",
  "portfolio.brokerSync.statusError": "Could not load synchronization status.",
  "portfolio.brokerSync.statusLoading": "Loading synchronization status…",
  "portfolio.brokerSync.errorGeneric": "Request failed: {reason}",
  "portfolio.brokerSync.errorUnknown": "The request failed.",
  "portfolio.brokerSync.errorValidation": "Validation failed: {reason}",
  "portfolio.brokerSync.settingsInvalid": "The settings file is damaged: {reason}. Set the options below and save to overwrite it. Empty secret fields keep the readable saved secrets.",
  "portfolio.brokerSync.settingsFileInvalidStatus": "The settings file is damaged: synchronization does not run until it is repaired.",
  "portfolio.brokerSync.secretUnknown": "Secret state is unknown",
  "portfolio.brokerSync.numbersInvalidBlocked": "Fix the highlighted values: settings were not saved.",
  "portfolio.brokerSync.saveTokenFirst": "Save the token first: the connection check uses only saved secrets.",
  "portfolio.brokerSync.checkWindow": "Checked window: {from} – {to}.",
  "portfolio.brokerSync.checkedAccountList": "Accounts checked: {accounts}.",
  "portfolio.brokerSync.failedAccountList": "Accounts that failed: {accounts}.",
  "portfolio.brokerSync.failedAccountItem": "{accountId}: {reason}",
  "portfolio.brokerSync.reasonAccountsUnavailable": "Operation history was not checked because the account list is unavailable.",
  "portfolio.brokerSync.reasonNoAccounts": "Operation history was not checked because the broker returned no accounts.",
  "portfolio.brokerSync.reasonSecretNotConfigured": "The token or secret is not set: save it in the settings above.",
  "portfolio.brokerSync.reasonInvalidCredentials": "The token or secret is invalid or expired: issue a new one and save it.",
  "portfolio.brokerSync.reasonAccessDenied": "The token does not give the required access: check its type and permissions.",
  "portfolio.brokerSync.reasonRateLimited": "The broker limited the request rate: repeat the check later.",
  "portfolio.brokerSync.reasonBrokerUnavailable": "The broker service is temporarily unavailable: repeat the check later.",
  "portfolio.brokerSync.reasonNetwork": "Could not reach the broker: check the network and retry.",
  "portfolio.brokerSync.reasonStatementSections": "The Interactive Brokers statement lacks required sections or fields: check the Activity Flex Query against the instructions above.",
  "portfolio.brokerSync.brokerErrorWithDetail": "{reason} Broker response: {detail}",
  "portfolio.brokerSync.brokerErrorUnknown": "Broker error: {detail}",
  "portfolio.brokerSync.counterDividendsUnconfirmedBasis": "Dividends with unconfirmed gross or net basis",
  "portfolio.brokerSync.counterSymbolsCreated": "Instruments created",
  "portfolio.brokerSync.counterProviderIssues": "Broker records with issues",
  "portfolio.brokerSync.counterRetryOperations": "Operations processed again",
  "portfolio.brokerSync.counterFinamTradeBlocks": "Finam: operations with a trade block skipped",
  "portfolio.brokerSync.counterIbkrAggregateSkipped": "IBKR: summary rows skipped (the detail rows are imported)",
  "portfolio.brokerSync.counterIbkrAggregateFallback": "IBKR: sections that had only summary rows (imported as is)",
  "portfolio.brokerSync.linkTitle": "Broker link",
  "portfolio.brokerSync.linkProvider": "Broker for synchronization",
  "portfolio.brokerSync.linkProviderDisabled": "Synchronization is off",
  "portfolio.brokerSync.linkFrom": "Import operations from",
  "portfolio.brokerSync.linkRequired": "Enter the broker account ID and the synchronization start date.",
  "portfolio.brokerSync.linkFailed": "Could not update the broker link.",
  "portfolio.brokerSync.cancel": "Cancel",
  "portfolio.brokerSync.saveLink": "Save",
};

export type TranslationKey = keyof typeof en;
